'use strict'

/**
 * 項目の上下を入れ替える機能
 * @param {*} targetList 入れ替えするリスト
 * @param {*} targetValue 入れ替えする値
 * @param {*} isUp 入れ替え先が上の場合はtrue、下の場合はfalse
 * @param {*} selectedRow 選択行の基準値も変更する場合は選択行を指定
*/
export function shiftListDetail(targetList, targetValue, isUp, selectedRow = null) {
  let result = {};
  // 入れ替え先が上の場合は1、下の場合は-1
  let sing = isUp ? 1 : -1;
  for (let targetDetail of targetList) {
    if (targetDetail.displayOrder == targetValue - 1 * sing) {
      // リスト内の入れ替え先の表示順を変更
      targetDetail.displayOrder = targetDetail.displayOrder + 1 * sing;
    } else if (targetDetail.displayOrder == targetValue) {
      // リスト内の選択行の表示順を変更
      let displayOrder = targetDetail.displayOrder - 1 * sing;
      targetDetail.displayOrder = displayOrder;
      if (selectedRow) {
        // 選択行がある場合は、選択行の表示順を変更
        selectedRow.displayOrder = displayOrder;
      }
    }
  }
  // 表示順の昇順でソート
  targetList.sort((a, b) => a.displayOrder < b.displayOrder ? -1 : 1);

  result.targetList = targetList;
  result.selectedRow = selectedRow;

  return result;
};


// WEBPACK FOOTER //
// ./src/components/mock/guest/patientdashboard/pDashboardUtil.js